import { db } from "../services/firebase";
import { collection, doc, setDoc, getDocs, query, where, orderBy, updateDoc, deleteDoc } from "firebase/firestore";

const NOTIFICATIONS_COLLECTION = "notifications";

// Servicio de notificaciones
export const notificationsService = {
    async sendNotification(userId, message, data = {}) {
        const notifRef = doc(collection(db, NOTIFICATIONS_COLLECTION));
        await setDoc(notifRef, {
            userId,
            message,
            data,
            date: new Date().toISOString(),
            read: false,
            type: data.tipo || "general",
        });
    },

    async sendOpportunityNotification(agentId, type, opportunityId, details = {}) {
        const messages = {
            approved: "Your opportunity has been approved and is now visible to investors.",
            rejected: "Your opportunity has been rejected. Please review the feedback and resubmit.",
            created: "Your opportunity has been submitted for approval.",
            updated: "Your opportunity has been updated.",
            deleted: "Your opportunity has been deleted."
        };

        const notification = {
            userId: agentId,
            type: "opportunity",
            action: type,
            opportunityId,
            message: messages[type] || "Opportunity status updated",
            details,
            date: new Date().toISOString(),
            read: false,
            priority: type === "rejected" ? "high" : "normal"
        };

        await this.sendNotification(agentId, notification.message, notification);
    },

    async getNotificationsForUser(userId, { onlyUnread = false, type, limitCount = 20 } = {}) {
        let q = query(collection(db, NOTIFICATIONS_COLLECTION), where("userId", "==", userId), orderBy("date", "desc"));
        if (onlyUnread) q = query(q, where("read", "==", false));
        if (type) q = query(q, where("type", "==", type));
        // Firestore doesn't support dynamic limit chaining, so limit in code
        const querySnapshot = await getDocs(q);
        let notifs = querySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
        if (limitCount) notifs = notifs.slice(0, limitCount);
        return notifs;
    },

    async markAsRead(notificationId) {
        const notifRef = doc(db, NOTIFICATIONS_COLLECTION, notificationId);
        await updateDoc(notifRef, { read: true });
    },

    async markAllAsRead(userId) {
        const q = query(collection(db, NOTIFICATIONS_COLLECTION), where("userId", "==", userId), where("read", "==", false));
        const querySnapshot = await getDocs(q);
        const batch = db.batch ? db.batch() : null;
        for (const docSnap of querySnapshot.docs) {
            if (batch) batch.update(docSnap.ref, { read: true });
            else await updateDoc(docSnap.ref, { read: true });
        }
        if (batch) await batch.commit();
    },

    async getUnreadCount(userId) {
        const q = query(collection(db, NOTIFICATIONS_COLLECTION), where("userId", "==", userId), where("read", "==", false));
        const querySnapshot = await getDocs(q);
        return querySnapshot.docs.length;
    },

    async deleteNotification(notificationId) {
        const notifRef = doc(db, NOTIFICATIONS_COLLECTION, notificationId);
        await deleteDoc(notifRef);
    },

    async deleteAllNotifications(userId) {
        const q = query(collection(db, NOTIFICATIONS_COLLECTION), where("userId", "==", userId));
        const querySnapshot = await getDocs(q);
        const batch = db.batch ? db.batch() : null;
        for (const docSnap of querySnapshot.docs) {
            if (batch) batch.delete(docSnap.ref);
            else await deleteDoc(docSnap.ref);
        }
        if (batch) await batch.commit();
    }
}; 